import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RIGHT_PANEL } from '../actions/uiActions'
import * as initializationActions from '../actions/viewInitializationActions'
import { useParams } from 'react-router'
import { graphStateHelper, stateHelper } from '../common/src/helpers'

// A conditional fetch is the one that may return a promise or undefined
export const useConditionalFetchOnLoad = fetchFn => {
  const [loading, setLoading] = useState(false)
  const effectFn = useCallback(async () => {
    const possiblePromise = fetchFn()
    if (possiblePromise) {
      setLoading(true)
      await possiblePromise
      setLoading(false)
    }
  }, [fetchFn])
  useEffect(() => {
    effectFn()
  }, [effectFn])
  return loading
}

export const useInitializeMsCollaborators = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(initializationActions.msCollaborators())
  }, [dispatch])
}

export const useSelectedItemId = () => {
  const params = useParams()
  return +params.id
}

export const useSelectedItem = () => {
  const selectedItemId = useSelectedItemId()
  return useSelector(state => stateHelper.getItem(state, selectedItemId))
}

export const useSelectedGraphItemId = () => {
  const params = useParams()
  const itemID = params.id
  return itemID?.startsWith('graph-') ? itemID.replace('graph-', '') : null
}

export const useSelectedGraphItem = () => {
  const graphItemId = useSelectedGraphItemId()
  return useSelector(state => graphStateHelper.getById(state, graphItemId))
}

export const useSelectedProjectId = () => {
  const params = useParams()
  return +params.pid
}

export const useSelectedProject = () => {
  const selectedProjectId = useSelectedProjectId()
  return useSelector(state => stateHelper.getProject(state, selectedProjectId))
}

const getRightPanel = (id, pid) => {
  if (id) {
    return id.startsWith('graph-') ? RIGHT_PANEL.GRAPH_RESOURCE : RIGHT_PANEL.ITEM
  }
  if (pid) {
    return RIGHT_PANEL.PROJECT
  }
  return RIGHT_PANEL.ITEM
}

export const useRightPanel = () => {
  const params = useParams()
  return getRightPanel(params.id, params.pid)
}

export const useSelection = () => {
  const itemID = useSelectedItemId()
  const graphResourceID = useSelectedGraphItemId()
  return useMemo(() => ({ itemID, graphResourceID }), [itemID, graphResourceID])
}
